import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "big-list" }
const _hoisted_2 = { class: "big-list--filter" }
const _hoisted_3 = { class: "count" }

import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Actions } from '@/store';
import GameItem from './GameItem.vue';
import ListFilter from '@/components/list-filter/ListFilter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameList',
  setup(__props) {

const store = useStore();

const filteredGames = computed(() => store.getters.filteredGames);
const gamesCount = computed<string>(
  () =>
    `${filteredGames.value.length} Game${
      filteredGames.value.length === 1 ? '' : 's'
    }`,
);

onMounted(() => {
  store.dispatch(Actions.GetGames);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(gamesCount)), 1),
      _createVNode(ListFilter)
    ]),
    _createElementVNode("ol", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredGames), (game) => {
        return (_openBlock(), _createBlock(GameItem, {
          game: game,
          key: game.key
        }, null, 8, ["game"]))
      }), 128))
    ])
  ]))
}
}

})